
const contents = "query StorylineSettingsClients {\n  settings {\n    stories {\n      viewerCanAccessStories\n    }\n    storyline {\n      viewerCanAccessStoryline\n      viewerCanPostStorylineAnnouncement\n      canUseDelegateTeamsOnStoryline\n    }\n  }\n}\n";
const sha256Hash = "98dc2188eccc6980228b04b9751813d96871822fb76e2127e2e8c9fd951841b4";
export default { contents: contents, sha256Hash: sha256Hash };
